import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CoreModule } from './core/core.module';
import { PortalService } from './core/services/portal.service';
import { BotsService } from './features/bots/services/bots.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ChatModule } from './widgets/chat/chat.module';

export function initPortal(appPortal: PortalService): any {
  return () => appPortal.load();
}

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule, AppRoutingModule, ChatModule],

  providers: [
    BotsService,
    PortalService,
    {
      provide: APP_INITIALIZER,
      useFactory: initPortal,
      deps: [PortalService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
